import { LoadingMojo } from "@classdojo/web";
import { ThemeUIStyleObject } from "@classdojo/web/nessie/stylingLib";
import React from "react";

// eslint-disable-next-line react-prefer-function-component/react-prefer-function-component
export default class OverlayError extends React.Component {
  state = {
    showError: false,
  };

  componentDidMount() {
    this.timer = setTimeout(this.displayError, 3000);
  }

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  render() {
    return (
      <div sx={overlayErrorErrorStyle}>
        <div>
          <LoadingMojo border={true} inline={true} />
          <div sx={overlayErrorMessageStyle}>
            {this.state.showError && <p>Oops! Please refresh the screen and try your action again.</p>}
          </div>
        </div>
      </div>
    );
  }

  timer: NodeJS.Timeout | undefined;

  displayError = () => {
    this.setState({ showError: true });
  };
}

const overlayErrorErrorStyle: ThemeUIStyleObject = {
  position: "fixed",
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  margin: "auto",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
};

const overlayErrorMessageStyle: ThemeUIStyleObject = {
  fontSize: "20px",
  fontWeight: 600,
  color: "dt_content_primary",
};
